import * as def from '@/definitions'
import { ColorConstruct } from '@/utilityModels/colorConstruct'
import { Layer } from './layer';
import { ObjectLayer } from './objectLayer';
import { ArrayHelper } from '@/helper/arrayHelper';
import { FontManager } from '@/model/fontManager/fontManager';
import { TableCellInfo } from './table/tableCellInfo';
import { DateHelper } from '@/helper/dateHelper';

export class CalendarLayer extends ObjectLayer
{
    // デフォルトフォントサイズ
    private static readonly DEFAULT_FONT_SIZE = 14;

    public get layerType() : string { return "calendar"; }

    // 年
    private _year : number = 2019;
    public get year() { return this._year; }
    public set year(year) { this._year = year; }

    // 月
    private _month : number = 1;
    public get month() { return this._month; }
    public set month(month) { this._month = month; }

    // 始まりの曜日
    // 0: 日曜, 1: 月曜
    private _startWeekDay : number = 0;
    public get startWeekDay() { return this._startWeekDay; }
    public set startWeekDay(startWeekDay) { this._startWeekDay = startWeekDay; }

    // 線色
    private _strokeColor : ColorConstruct = new ColorConstruct();
    public get strokeColor() { return this._strokeColor; }
    public set strokeColor(strokeColor) { this._strokeColor = strokeColor; }

    // 線幅
    private _strokeWidth : number = 0.5;
    public get strokeWidth() { return this._strokeWidth; }
    public set strokeWidth(strokeWidth) { this._strokeWidth = strokeWidth; }

    // 日:フォントId
    private _dayFontId = FontManager.DEFAULT_FONT_ID;
    public get dayFontId() { return this._dayFontId; }
    public set dayFontId(dayFontId) { this._dayFontId = dayFontId; }

    // 平日テキスト色
    private _weekDaysColor = new ColorConstruct(0, 0, 0);
    public get weekDaysColor() { return this._weekDaysColor; }
    public set weekDaysColor(weekDaysColor) { this._weekDaysColor = weekDaysColor; }

    // 土曜テキスト色
    private _saturdayColor = new ColorConstruct(52, 134, 224);
    public get saturdayColor() { return this._saturdayColor; }
    public set saturdayColor(saturdayColor) { this._saturdayColor = saturdayColor; }

    // 日曜テキスト色
    private _sundayColor = new ColorConstruct(255, 74, 74);
    public get sundayColor() { return this._sundayColor; }
    public set sundayColor(sundayColor) { this._sundayColor = sundayColor; }

    // 日:フォントサイズ
    private _dayFontSize = CalendarLayer.DEFAULT_FONT_SIZE;
    public get dayFontSize() { return this._dayFontSize; }
    public set dayFontSize(dayFontSize) { this._dayFontSize = dayFontSize; }

    // 水平揃え
    // 0: 左
    // 1: 中央
    // 2: 右
    private _horizontalAlignment : number = 0;
    public get horizontalAlignment() : number { return this._horizontalAlignment; }
    public set horizontalAlignment(horizontalAlignment : number) { this._horizontalAlignment = horizontalAlignment; }

    // 垂直揃え
    // 0: 上
    // 1: 中央
    // 2: 下
    private _verticalAlignment : number = 0;
    public get verticalAlignment() : number { return this._verticalAlignment; }
    public set verticalAlignment(verticalAlignment : number) { this._verticalAlignment = verticalAlignment; }

    // 日:太字
    public dayBold : boolean = false;
    // 日:斜体
    public dayItalic : boolean = false;

    // 年
    // 0: なし
    // 1: 2018
    // 6: 2018年
    // 3: 平成30
    // 7: 平成30年
    // 4: H30
    private _yearType : number = 6;
    public get yearType() { return this._yearType; }
    public set yearType(yearType) { this._yearType = yearType; }

    // 年:フォントId
    private _yearFontId = FontManager.DEFAULT_FONT_ID;
    public get yearFontId() { return this._yearFontId; }
    public set yearFontId(yearFontId) { this._yearFontId = yearFontId; }

    // 年：テキスト色
    private _yearColor = new ColorConstruct(0, 0, 0);
    public get yearColor() { return this._yearColor; }
    public set yearColor(yearColor) { this._yearColor = yearColor; }

    // 年:フォントサイズ
    private _yearFontSize = CalendarLayer.DEFAULT_FONT_SIZE;
    public get yearFontSize() { return this._yearFontSize; }
    public set yearFontSize(yearFontSize) { this._yearFontSize = yearFontSize; }

    // 年:太字
    public yearBold : boolean = false;
    // 年:斜体
    public yearItalic : boolean = false;
    // 年:下線
    public yearUnderline : boolean = false;

    // 月
    // 1: 8
    // 4: 8月
    // 2: August
    // 3: Aug
    private _monthType : number = 4;
    public get monthType() { return this._monthType; }
    public set monthType(monthType) { this._monthType = monthType; }

    // 月:フォントId
    private _monthFontId = FontManager.DEFAULT_FONT_ID;
    public get monthFontId() { return this._monthFontId; }
    public set monthFontId(monthFontId) { this._monthFontId = monthFontId; }

    // 月：テキスト色
    private _monthColor = new ColorConstruct(0, 0, 0);
    public get monthColor() { return this._monthColor; }
    public set monthColor(monthColor) { this._monthColor = monthColor; }

    // 月:フォントサイズ
    private _monthFontSize = CalendarLayer.DEFAULT_FONT_SIZE;
    public get monthFontSize() { return this._monthFontSize; }
    public set monthFontSize(monthFontSize) { this._monthFontSize = monthFontSize; }

    // 月:太字
    public monthBold : boolean = false;
    // 月:斜体
    public monthItalic : boolean = false;
    // 月:下線
    public monthUnderline : boolean = false;

    // 曜日
    // 0: なし
    // 1: TuesDay
    // 2: Tue
    // 5: 火
    // 11: T
    private _weekDayType : number = 5;
    public get weekDayType() { return this._weekDayType; }
    public set weekDayType(weekDayType) { this._weekDayType = weekDayType; }

    // 曜日:フォントId
    private _weekDayFontId = FontManager.DEFAULT_FONT_ID;
    public get weekDayFontId() { return this._weekDayFontId; }
    public set weekDayFontId(weekDayFontId) { this._weekDayFontId = weekDayFontId; }

    // 月:フォントサイズ
    private _weekDayFontSize = CalendarLayer.DEFAULT_FONT_SIZE;
    public get weekDayFontSize() { return this._weekDayFontSize; }
    public set weekDayFontSize(weekDayFontSize) { this._weekDayFontSize = weekDayFontSize; }

    // 曜日:太字
    public weekDayBold : boolean = false;
    // 曜日:斜体
    public weekDayItalic : boolean = false;

    // 作成
    public static create(x : number, y : number, width : number, height : number) : CalendarLayer
    {
        var layer = new CalendarLayer();
        layer.x = x;
        layer.y = y;
        layer.width = width;
        layer.height = height;

        // 現在日付を初期値とする
        var today = DateHelper.getDateToday();
        layer.year = today.getFullYear();
        layer.month = today.getMonth() + 1;

        return layer;
    }

    // 複製
    public clone()
    {
        var cloned = new CalendarLayer();
        this.cloneParameter(cloned);
        return cloned;
    }

    public cloneParameter(layer : CalendarLayer)
    {
        layer.year = this.year;
        layer.month = this.month;
        layer.startWeekDay = this.startWeekDay;
        layer.strokeColor = this.strokeColor.clone();
        layer.strokeWidth = this.strokeWidth;
        layer.dayFontId = this.dayFontId;
        layer.weekDaysColor = this.weekDaysColor.clone();
        layer.saturdayColor = this.saturdayColor.clone();
        layer.sundayColor = this.sundayColor.clone();
        layer.dayFontSize = this.dayFontSize;
        layer.horizontalAlignment = this.horizontalAlignment;
        layer.verticalAlignment = this.verticalAlignment;
        layer.dayBold = this.dayBold;
        layer.dayItalic = this.dayItalic;
        layer.yearType = this.yearType;
        layer.yearFontId = this.yearFontId;
        layer.yearColor = this.yearColor.clone();
        layer.yearFontSize = this.yearFontSize;
        layer.yearBold = this.yearBold;
        layer.yearItalic = this.yearItalic;
        layer.yearUnderline = this.yearUnderline;
        layer.monthType = this.monthType;
        layer.monthFontId = this.monthFontId;
        layer.monthColor = this.monthColor.clone();
        layer.monthFontSize = this.monthFontSize;
        layer.monthBold = this.monthBold;
        layer.monthItalic = this.monthItalic;
        layer.monthUnderline = this.monthUnderline;
        layer.weekDayType = this.weekDayType;
        layer.weekDayFontId = this.weekDayFontId;
        layer.weekDayFontSize = this.weekDayFontSize;
        layer.weekDayBold = this.weekDayBold;
        layer.weekDayItalic = this.weekDayItalic;

        super.cloneParameter(layer);
    }

    // JSON
    public toJSON()
    {
        var jsonObj = {};
        jsonObj = this.saveParameterToJson(jsonObj);
        return jsonObj;
    }

    public saveParameterToJson(jsonObject)
    {
        jsonObject.year = this.year;
        jsonObject.month = this.month;
        jsonObject.startWeekDay = this.startWeekDay;
        jsonObject.strokeColor = this.strokeColor;
        jsonObject.strokeWidth = this.strokeWidth;
        jsonObject.dayFontId = this.dayFontId;
        jsonObject.weekDaysColor = this.weekDaysColor;
        jsonObject.saturdayColor = this.saturdayColor;
        jsonObject.sundayColor = this.sundayColor;
        jsonObject.dayFontSize = this.dayFontSize;
        jsonObject.horizontalAlignment = this.horizontalAlignment;
        jsonObject.verticalAlignment = this.verticalAlignment;
        jsonObject.dayBold = this.dayBold;
        jsonObject.dayItalic = this.dayItalic;
        jsonObject.yearType = this.yearType;
        jsonObject.yearFontId = this.yearFontId;
        jsonObject.yearColor = this.yearColor;
        jsonObject.yearFontSize = this.yearFontSize;
        jsonObject.yearBold = this.yearBold;
        jsonObject.yearItalic = this.yearItalic;
        jsonObject.yearUnderline = this.yearUnderline;
        jsonObject.monthType = this.monthType;
        jsonObject.monthFontId = this.monthFontId;
        jsonObject.monthColor = this.monthColor;
        jsonObject.monthFontSize = this.monthFontSize;
        jsonObject.monthBold = this.monthBold;
        jsonObject.monthItalic = this.monthItalic;
        jsonObject.monthUnderline = this.monthUnderline;
        jsonObject.weekDayType = this.weekDayType;
        jsonObject.weekDayFontId = this.weekDayFontId;
        jsonObject.weekDayFontSize = this.weekDayFontSize;
        jsonObject.weekDayBold = this.weekDayBold;
        jsonObject.weekDayItalic = this.weekDayItalic;

        jsonObject = super.saveParameterToJson(jsonObject);

        return jsonObject;
    }

    public static createFromJsonData(jsonData : any) : CalendarLayer
    {
        var layer = new CalendarLayer();
        layer.loadParameterFromJson(jsonData);
        return layer;
    }

    public loadParameterFromJson(jsonData)
    {
        if(jsonData.year != null) { this.year = jsonData.year; }
        if(jsonData.month != null) { this.month = jsonData.month; }
        if(jsonData.startWeekDay != null) { this.startWeekDay = jsonData.startWeekDay; }
        if(jsonData.strokeColor != null) { this.strokeColor = ColorConstruct.createFromJsonData(jsonData.strokeColor); }
        if(jsonData.strokeWidth != null) { this.strokeWidth = jsonData.strokeWidth; }
        if(jsonData.dayFontId != null) 
        {
            var fontId = jsonData.dayFontId;
            if(!FontManager.isWebFont(jsonData.dayFontId))
            {
                // ローカルフォントをコンバート
                fontId = FontManager.convertLocalToWebFontIfNeeded(jsonData.dayFontId);
                if(fontId != jsonData.dayFontId)
                {
                    // コンバートしたフォントを一時的に保存
                    FontManager.storeUnloadedFontIdIfNew(jsonData.dayFontId);
                }
            }
            this.dayFontId = fontId;  
        }
        if(jsonData.weekDaysColor != null) { this.weekDaysColor = ColorConstruct.createFromJsonData(jsonData.weekDaysColor); }
        if(jsonData.saturdayColor != null) { this.saturdayColor = ColorConstruct.createFromJsonData(jsonData.saturdayColor); }
        if(jsonData.sundayColor != null) { this.sundayColor = ColorConstruct.createFromJsonData(jsonData.sundayColor); }
        if(jsonData.dayFontSize != null) { this.dayFontSize = jsonData.dayFontSize; }
        if(jsonData.horizontalAlignment != null) { this.horizontalAlignment = jsonData.horizontalAlignment; }
        if(jsonData.verticalAlignment != null) { this.verticalAlignment = jsonData.verticalAlignment; }
        if(jsonData.dayBold != null) { this.dayBold = jsonData.dayBold; }
        if(jsonData.dayItalic != null) { this.dayItalic = jsonData.dayItalic; }
        if(jsonData.yearType != null) { this.yearType = jsonData.yearType; }
        if(jsonData.yearFontId != null) 
        { 
            var fontId = jsonData.yearFontId;
            if(!FontManager.isWebFont(jsonData.yearFontId))
            {
                // ローカルフォントをコンバート
                fontId = FontManager.convertLocalToWebFontIfNeeded(jsonData.yearFontId);
                if(fontId != jsonData.yearFontId)
                {
                    // コンバートしたフォントを一時的に保存
                    FontManager.storeUnloadedFontIdIfNew(jsonData.yearFontId);
                }
            }
            this.yearFontId = fontId;  
        }
        if(jsonData.yearColor != null) { this.yearColor = ColorConstruct.createFromJsonData(jsonData.yearColor); }
        if(jsonData.yearFontSize != null) { this.yearFontSize = jsonData.yearFontSize; }
        if(jsonData.yearBold != null) { this.yearBold = jsonData.yearBold; }
        if(jsonData.yearItalic != null) { this.yearItalic = jsonData.yearItalic; }
        if(jsonData.yearUnderline != null) { this.yearUnderline = jsonData.yearUnderline; }
        if(jsonData.monthType != null) { this.monthType = jsonData.monthType; }
        if(jsonData.monthFontId != null) 
        { 
            var fontId = jsonData.monthFontId;
            if(!FontManager.isWebFont(jsonData.monthFontId))
            {
                // ローカルフォントをコンバート
                fontId = FontManager.convertLocalToWebFontIfNeeded(jsonData.monthFontId);
                if(fontId != jsonData.monthFontId)
                {
                    // コンバートしたフォントを一時的に保存
                    FontManager.storeUnloadedFontIdIfNew(jsonData.monthFontId);
                }
            }
            this.monthFontId = fontId;  
        }
        if(jsonData.monthColor != null) { this.monthColor = ColorConstruct.createFromJsonData(jsonData.monthColor); }
        if(jsonData.monthFontSize != null) { this.monthFontSize = jsonData.monthFontSize; }
        if(jsonData.monthBold != null) { this.monthBold = jsonData.monthBold; }
        if(jsonData.monthItalic != null) { this.monthItalic = jsonData.monthItalic; }
        if(jsonData.monthUnderline != null) { this.monthUnderline = jsonData.monthUnderline; }
        if(jsonData.weekDayType != null) { this.weekDayType = jsonData.weekDayType; }
        if(jsonData.weekDayFontId != null)
        { 
            var fontId = jsonData.weekDayFontId;
            if(!FontManager.isWebFont(jsonData.weekDayFontId))
            {
                // ローカルフォントをコンバート
                fontId = FontManager.convertLocalToWebFontIfNeeded(jsonData.weekDayFontId);
                if(fontId != jsonData.weekDayFontId)
                {
                    // コンバートしたフォントを一時的に保存
                    FontManager.storeUnloadedFontIdIfNew(jsonData.weekDayFontId);
                }
            }
            this.weekDayFontId = fontId;  
        }
        if(jsonData.weekDayFontSize != null) { this.weekDayFontSize = jsonData.weekDayFontSize; }
        if(jsonData.weekDayBold != null) { this.weekDayBold = jsonData.weekDayBold; }
        if(jsonData.weekDayItalic != null) { this.weekDayItalic = jsonData.weekDayItalic; }

        super.loadParameterFromJson(jsonData);
    }
}